import { selectedAlertsConstants } from "../_constants";

export const selectAlerts = ids => ({
  type: selectedAlertsConstants.SELECT,
  ids
});

export const deselectAlerts = ids => ({
  type: selectedAlertsConstants.DESELECT,
  ids
});

export const clearSelectedAlerts = () => ({
  type: selectedAlertsConstants.CLEAR
});



// WEBPACK FOOTER //
// ./src/_actions/selectedAlerts.actions.js